module.exports = __webpack_public_path__ + "img/EA.c2f80d15.svg";